export enum Order {
  昇順 = "ASC",
  降順 = "DESC",
}
